import { render } from "./ShowQuizCompleted.vue?vue&type=template&id=5390d9d6&scoped=true"
import script from "./ShowQuizCompleted.vue?vue&type=script&lang=js"
export * from "./ShowQuizCompleted.vue?vue&type=script&lang=js"

import "./ShowQuizCompleted.vue?vue&type=style&index=0&id=5390d9d6&scoped=true&lang=css"

import exportComponent from "/home/marco/keyos-projects/esamiFinanza/webapp-esamifinanza/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5390d9d6"]])

export default __exports__